import React from "react";
import {InputPath} from "../types/InputPath.ts";


export type FormInputHook<T> = (v: InputPath<T>, config: object) => [
  value: T,
  setValue: (value: T) => void,
  hasError: boolean
]


export const FormInputContext = React.createContext<FormInputHook<any>>(() => ([
  undefined,
  () => {},
  false
]));


